import { useState, useEffect } from 'react'
import PageNavigation from '../../../components/PageNavigation/PageNavigation'
import './Support.css'

const Support = () => {
  const [activeSection, setActiveSection] = useState('contact')

  const sections = [
    { id: 'contact', title: 'Contact Support' },
    { id: 'tiers', title: 'Support Tiers' },
    { id: 'before-contacting', title: 'Before Contacting Support' },
    { id: 'community', title: 'Community Resources' },
    { id: 'feature-requests', title: 'Feature Requests' }
  ]

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 200

      for (let i = sections.length - 1; i >= 0; i--) {
        const element = document.getElementById(`support-${sections[i].id}`)
        if (element && element.offsetTop <= scrollPosition) {
          setActiveSection(sections[i].id)
          break
        }
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()
    return () => window.removeEventListener('scroll', handleScroll)
  }, [sections])

  return (
    <div className="support-page">
      <div className="support-content-wrapper">
        <div className="support-main-content">
      <h1>Support</h1>
      <p className="intro">
        Get help with Aedify.AI. We're here to assist you with any questions or issues you may have.
      </p>

          <section id="support-contact" className="support-section">
        <h2>Contact Support</h2>
        <p>
          Reach out to our support team through any of the following channels:
        </p>
        <div className="support-options">
          <div className="support-option">
            <h3>Email Support</h3>
            <p>
              Send us an email at <a href="mailto:support@aedify.ai">support@aedify.ai</a>. 
              We typically respond within 24 hours.
            </p>
          </div>
          <div className="support-option">
            <h3>In-App Support</h3>
            <p>
              Use the in-app support chat available in your dashboard. Our team is available 
              during business hours.
            </p>
          </div>
          <div className="support-option">
            <h3>Documentation</h3>
            <p>
              Browse our comprehensive documentation for guides, tutorials, and API references.
            </p>
          </div>
        </div>
      </section>

          <section id="support-tiers" className="support-section">
        <h2>Support Tiers</h2>
        <h3>Community Support</h3>
        <p>
          Available to all users. Includes access to documentation, community forums, and 
          email support with standard response times.
        </p>
        <h3>Priority Support</h3>
        <p>
          Available for enterprise customers. Includes faster response times, dedicated support 
          channels, and priority assistance.
        </p>
      </section>

          <section id="support-before-contacting" className="support-section">
        <h2>Before Contacting Support</h2>
        <p>
          To help us assist you more effectively, please have the following information ready:
        </p>
        <ul>
          <li>Your account email or username</li>
          <li>Description of the issue or question</li>
          <li>Steps to reproduce (if applicable)</li>
          <li>Error messages or logs</li>
          <li>Browser/OS information (if relevant)</li>
        </ul>
      </section>

          <section id="support-community" className="support-section">
        <h2>Community Resources</h2>
        <p>
          Join our community to connect with other users and get help:
        </p>
        <ul>
          <li><a href="/resources/community">Community Forum</a> - Ask questions and share knowledge</li>
          <li><a href="/resources/faq">FAQ</a> - Common questions and answers</li>
          <li>GitHub Discussions - Technical discussions and feature requests</li>
        </ul>
      </section>

          <section id="support-feature-requests" className="support-section">
        <h2>Feature Requests</h2>
        <p>
          Have an idea for a new feature? We'd love to hear from you! Submit feature requests 
          through the in-app feedback form or email us at <a href="mailto:support@aedify.ai">support@aedify.ai</a>.
        </p>
      </section>

          <PageNavigation />
        </div>

        {/* Right Sidebar - Section Navigation */}
        <aside className="support-sidebar">
          <div className="sidebar-section">
            <h3>Contents</h3>
            <nav className="section-nav">
              {sections.map((section) => (
                <a
                  key={section.id}
                  href={`#support-${section.id}`}
                  className={`section-nav-item ${activeSection === section.id ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault()
                    setActiveSection(section.id)
                    document.getElementById(`support-${section.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
                  }}
                >
                  {section.title}
                </a>
              ))}
            </nav>
          </div>
        </aside>
      </div>
    </div>
  )
}

export default Support
